import { styled } from 'stitches.config'

export const StampContainer = styled('div', {
  size: '96px',

  '@bp2': {
    size: '144px',
  },
})
